import Cookies from 'js-cookie';
import React, { useContext, useState } from 'react';
import { AdminContext } from '../../context/AdminContext';
import CookieFunction from '../../functions/cookieFunction';
import AppIcons from '../../icons';
// import { AdminContext } from '../../../context/AdminContext';
import Checkbox from '../CheckBox';
import styles from './styles.module.scss';

const ThemeBox = ({
  content,
  onClickColor = () => console.log('theme'),
  extraClassName = 'nothing',
}) => {
  const {
    themeColor,
    setThemeColor,
    kidMode,
    setKidMode,
    threeDMode,
    setThreeDMode,
    themeMode,
  } = useContext(AdminContext);
  const [activeColor, setActiveColor] = useState(themeColor);

  const changeActiveColor = (x) => {
    // Cookies.set('ochattColor', x, {
    //   expires: 365,
    // });
    // console.log('theme===', Cookies.get('ochattColor'));
    // setThemeColor(Cookies.get('ochattColor'));
    // setActiveColor(Cookies.get('ochattColor'));
    CookieFunction('set', 'ochattColor', x, () => {
      setThemeColor(CookieFunction('get', 'ochattColor'));
      setActiveColor(CookieFunction('get', 'ochattColor'));
    });
    // setShowProfileMenu(false);
  };

  const handleCheckbox = () => {
    if (kidMode == true) {
      setKidMode(false);
      // Cookies.remove('ochattKid');
      CookieFunction('remove', 'ochattKid');
    } else {
      CookieFunction('set', 'ochattKid', 'true');

      // Cookies.set('ochattKid', 'true', {
      //   expires: 365,
      // });
      setKidMode(true);
    }
  };
  const handleCheckboxThreeD = () => {
    if (threeDMode == true) {
      setThreeDMode(false);
      // Cookies.set('ochattThreeD', 'false', {
      //   expires: 365,
      // });
      CookieFunction('set', 'ochattThreeD', 'false');
    } else {
      CookieFunction('set', 'ochattThreeD', 'true');
      // Cookies.set('ochattThreeD', 'true', {
      //   expires: 365,
      // });
      setThreeDMode(true);
    }
  };
  console.log('kidMode', kidMode, threeDMode);
  // useEffect(() => {}, [kidMode, threeDMode]);
  return (
    <div className={`${styles.ProfileMenuMiddle} noBorder `}>
      {/* <p>{content?.toolbar?.theme?.title}</p> */}
      <div
        className={`flex flex-col justify-start items-start w-full ${extraClassName}`}
      >
        {content?.themeArray?.map((item, index) => (
          <div
            className={`flex flex-row justify-between items-center my-[8px] mx-[2px] cursor-pointer w-full ${styles.singleItem}`}
            onClick={() => {
              changeActiveColor(item?.color);
              onClickColor();
            }}
            key={index}
          >
            <div className={`mx-8px ${themeMode != 'white' && 'textWhite'}`}>
              {item?.text}
            </div>
            <div
              className={`${
                styles.color
              } bg-white-theme flex justify-center items-center ${` ${styles.unActive} checkboxCircle`}`}
            >
              {themeColor == item?.color && (
                <AppIcons.checkIcon width={8} height={11} />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ThemeBox;
